// Typelizer digest e415f9ac0011bb3fb04c27967b5f06a4
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** GET /c/:company_id/ledger/review_queue */
  show: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/c/:company_id/ledger/review_queue', {}, options),
    method: 'get',
  }),
}
